import Operation from './Operation';

export default class Minimum extends Operation {
  cal (a, b) {
    // cant use vector for now
    if (a === null || a === undefined) {
      return Number(b);
    }
    a = Number(a);
    b = Number(b);
    return Math.min(a, b);
  }
}


// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Minimum.js